export function formatDateLocalYYYYMMDD(date: Date | string | number | null | undefined): string | undefined {
  if (!date) return undefined;
  const d = date instanceof Date ? date : new Date(date);
  // Format as YYYY-MM-DD using the user's local timezone
  return d.toLocaleDateString('en-CA');
}
